import React from "react";
import {Link, Outlet} from "react-router-dom";
import {Paths} from "../paths";
import {useAuth} from "../store/AuthContext";
import UserNav from "../components/nav/UserNav";
import {FaHome} from "react-icons/fa";
import {RiLogoutCircleRLine} from "react-icons/ri";

const UserLayout = () => {
    const {logOut, user} = useAuth();

    const onLogout = async () => {
        await logOut();
    }

    return (
        <>
            <header>
                <Link to={Paths.user} className={"d-flex ai-center ps-3 h5 gap-2 pointer text-decoration-none"}>
                    <FaHome/>
                    <span className={"pt-1"}>Главная</span>
                </Link>
                <div className={"d-flex gap-3"}>
                    <Link to={"/sections"}>Анкеты объектов</Link>
                    <Link to={"/editor"}>Задачи</Link>
                </div>
                <div className={"d-flex gap-3"}>
                    <div className={"header-user"}>
                        {(() => {
                            if (user.users_info && user.users_info.firstname && user.users_info.lastname) {
                                const firstname = user.users_info.firstname[0].toUpperCase();
                                const lastname = user.users_info.lastname[0].toUpperCase();

                                return <span className={"user-icon"}>{firstname}{lastname}</span>;
                            } else {
                                if (user.role === "ADMIN") {
                                    return <span className={"user-icon"}>А</span>;
                                }
                                if (user.role === "USER") {
                                    return <span className={"user-icon"}>П</span>;
                                }
                            }
                            return null;
                        })()}
                        <div>
                            <div className={"h6"}>
                                {user.role === "ADMIN" && "Администратор"}
                                {user.role === "USER" && "Пользователь"}
                            </div>
                            <div> {user.email}</div>
                        </div>

                    </div>
                    <div className={"header-right"}>
                        <div className={"d-flex ai-center h6 gap-2 pointer"} onClick={() => onLogout()}>
                            <RiLogoutCircleRLine/>
                            Выйти
                        </div>
                    </div>
                </div>
            </header>
            <main className="d-flex flex-nowrap" style={{paddingTop: "4rem"}}>
                <div className="sections" style={{width: "15rem"}}>
                    <UserNav/>
                </div>
                <div className={"d-flex flex-column p-3 w-100 vh-100"}>
                    <Outlet/>
                </div>
            </main>
        </>
    );
};

export default UserLayout;